export default __webpack_public_path__ + "static/crescent@2x-c896b74823b180fd023f86582a8dcde2.jpg";